import mock from "@/@fake-db/mock";
/* eslint-disable global-require */
const data = {
  congratulations: {
    name: "John",
    saleToday: "48900",
  },
  statisticsItems: [
    {
      icon: "TrendingUpIcon",
      color: "light-primary",
      title: "230k",
      subtitle: "Sales",
      customClass: "mb-2 mb-xl-0",
    },
    {
      icon: "UserIcon",
      color: "light-info",
      title: "8.549k",
      subtitle: "Customers",
      customClass: "mb-2 mb-xl-0",
    },
    {
      icon: "BoxIcon",
      color: "light-danger",
      title: "1.423k",
      subtitle: "Products",
      customClass: "mb-2 mb-sm-0",
    },
    {
      icon: "DollarSignIcon",
      color: "light-success",
      title: "$9745",
      subtitle: "Revenue",
      customClass: "",
    },
  ],
  statisticsOrder: {
    series: [
      {
        name: "2020",
        data: [45, 85, 65, 45, 65],
      },
    ],
  },
  statisticsProfit: {
    series: [
      {
        data: [0, 20, 5, 30, 15, 45],
      },
    ],
  },
  earningsChart: {
    series: [53, 16, 31],
  },
  revenue: {
    years: ["2023", "2024", "2025"],
    price: "25,852",
    budget: "56,800",
    revenueReport: {
      series: [
        {
          name: "Earning",
          data: [95, 177, 284, 256, 105, 63, 168, 218, 72],
        },
        // {
        //   name: 'Expense',
        //   data: [-145, -80, -60, -180, -100, -60, -85, -75, -100],
        // },
      ],
    },
    budgetChart: {
      series: [
        {
          data: [61, 48, 69, 52, 60, 40, 79, 60, 59, 43, 62],
        },
        {
          data: [20, 10, 30, 15, 23, 0, 25, 15, 20, 5, 27],
        },
      ],
    },
  },
  companyTable: [
    {
      avatarImg: require("@/assets/images/icons/toolbox.svg"),
      title: "Dixons",
      subtitle: "meguc@ruj.io",
      avatarIcon: "MonitorIcon",
      avatarColor: "light-primary",
      avatarTitle: "Technology",
      viewTitle: "23.4k",
      viewsub: "in 24 hours",
      revenue: "891.2",
      sales: "68",
      loss: true,
    },
    {
      avatarImg: require("@/assets/images/icons/parachute.svg"),
      title: "Motels",
      subtitle: "vecav@hodzi.co.uk",
      avatarIcon: "CoffeeIcon",
      avatarColor: "light-success",
      avatarTitle: "Grocery",
      viewTitle: "78k",
      viewsub: "in 2 days",
      revenue: "668.51",
      sales: "97",
      loss: false,
    },
    {
      avatarImg: require("@/assets/images/icons/brush.svg"),
      title: "Zipcar",
      subtitle: "davcilse@is.gov",
      avatarIcon: "WatchIcon",
      avatarColor: "light-warning",
      avatarTitle: "Fashion",
      viewTitle: "162",
      viewsub: "in 5 days",
      revenue: "522.29",
      sales: "62",
      loss: false,
    },
    {
      avatarImg: require("@/assets/images/icons/star.svg"),
      title: "Owning",
      subtitle: "us@cuhil.gov",
      avatarIcon: "MonitorIcon",
      avatarColor: "light-primary",
      avatarTitle: "Technology",
      viewTitle: "214",
      viewsub: "in 24 hours",
      revenue: "291.01",
      sales: "88",
      loss: false,
    },
    {
      avatarImg: require("@/assets/images/icons/book.svg"),
      title: "Cafés",
      subtitle: "pudais@jife.com",
      avatarIcon: "CoffeeIcon",
      avatarColor: "light-success",
      avatarTitle: "Grocery",
      viewTitle: "208",
      viewsub: "in 1 week",
      revenue: "783.93",
      sales: "16",
      loss: true,
    },
    {
      avatarImg: require("@/assets/images/icons/rocket.svg"),
      title: "Kmart",
      subtitle: "bipri@cawiw.com",
      avatarIcon: "WatchIcon",
      avatarColor: "light-warning",
      avatarTitle: "Fashion",
      viewTitle: "990",
      viewsub: "in 1 month",
      revenue: "780.05",
      sales: "78",
      loss: false,
    },
    {
      avatarImg: require("@/assets/images/icons/speaker.svg"),
      title: "Payers",
      subtitle: "luk@izug.io",
      avatarIcon: "WatchIcon",
      avatarColor: "light-warning",
      avatarTitle: "Fashion",
      viewTitle: "12.9k",
      viewsub: "in 12 hours",
      revenue: "531.49",
      sales: "42",
      loss: false,
    },
  ],
  meetup: {
    mediaData: [
      {
        avatar: "CalendarIcon",
        title: "Sat, May 25, 2020",
        subtitle: "10:AM to 6:PM",
      },
      {
        avatar: "MapPinIcon",
        title: "Central Park",
        subtitle: "Manhattan, New york City",
      },
    ],
    avatars: [
      {
        avatar: require("@/assets/images/portrait/small/avatar-s-9.jpg"),
        fullName: "Billy Hopkins",
      },
      {
        avatar: require("@/assets/images/portrait/small/avatar-s-6.jpg"),
        fullName: "Amy Carson",
      },
      {
        avatar: require("@/assets/images/portrait/small/avatar-s-8.jpg"),
        fullName: "Brandon Miles",
      },
      {
        avatar: require("@/assets/images/portrait/small/avatar-s-7.jpg"),
        fullName: "Daisy Weber",
      },
      {
        avatar: require("@/assets/images/portrait/small/avatar-s-20.jpg"),
        fullName: "Jenny Looper",
      },
    ],
  },
  goalOverview: {
    completed: "786,617",
    inProgress: "13,561",
    series: [83],
  },
  transactionData: [
    {
      mode: "Wallet",
      types: "Starbucks",
      avatar: "PocketIcon",
      avatarVariant: "light-primary",
      payment: "-$74",
      deduction: true,
    },
    {
      mode: "Bank Transfer",
      types: "Add Money",
      avatar: "CheckIcon",
      avatarVariant: "light-success",
      payment: "+$480",
      deduction: false,
    },
    {
      mode: "Paypal",
      types: "Add Money",
      avatar: "DollarSignIcon",
      avatarVariant: "light-danger",
      payment: "+$480",
      deduction: false,
    },
    {
      mode: "Mastercard",
      types: "Ordered Food",
      avatar: "CreditCardIcon",
      avatarVariant: "light-warning",
      payment: "-$23",
      deduction: true,
    },
    {
      mode: "Transfer",
      types: "Refund",
      avatar: "TrendingUpIcon",
      avatarVariant: "light-info",
      payment: "+$98",
      deduction: false,
    },
  ],
  dashboardOrders: [
    {
      name: "Abdul Rehman",
      amount: "AED 554.5",
      avatarOrder: require("@/assets/images/avatars/Arabi.png"),
      deduction: true,
    },
    {
      name: "Hamad Hasan",
      amount: "AED 87.32",
      avatarOrder: require("@/assets/images/avatars/2.png"),
      deduction: true,
    },
    {
      name: "Ebad Ali",
      amount: "AED 126.4",
      avatarOrder: require("@/assets/images/avatars/13.png"),
      deduction: true,
    },
    {
      name: "Ahmed Khan",
      amount: "AED 87.32",
      avatarOrder: require("@/assets/images/avatars/12.png"),
      deduction: true,
    },
    {
      name: "Hamad Hasan",
      amount: "AED 87.32",
      avatarOrder: require("@/assets/images/avatars/2.png"),
      deduction: true,
    },
  ],
  orderStatistics: {
    completed: "786,617",
    inProgress: "13,561",
    series: [78],
  },
  products: [
    {
      id: 1,
      name: "VicTsing Wireless Mouse",
      slug: "vic-tsing-wireless-mouse-1",
      description:
        "After thousands of samples of palm data, we designed this ergonomic mouse. The laptop mouse has a streamlined arc and thumb rest to help reduce the stress caused by prolonged use of the laptop mouse.",
      brand: "VicTsing",
      price: 10.99,
      image: require("@/assets/images/pages/eCommerce/27.png"),
      hasFreeShipping: true,
      rating: 3,
      qty: 2,
    },
    {
      id: 2,
      name: "Bluetooth Audio Sunglasses",
      slug:
        "bose-frames-tenor-rectangular-polarized-bluetooth-audio-sunglasses-2",
      description:
        "Redesigned for luxury — Thoughtfully refined and strikingly elegant, the latest Bose sunglasses blend enhanced features and designs for an elevated way to listen",
      brand: "Bose",
      price: 249.0,
      image: require("@/assets/images/pages/eCommerce/26.png"),
      hasFreeShipping: false,
      rating: 4,
      qty: 12,
    },
    {
      id: 3,
      name: "Willful Smart Watch",
      slug: "willful-smart-watch-for-men-women-2020-3",
      description:
        "Are you looking for a smart watch, which can not only easily keep tracking of your steps, calories, heart rate and sleep quality, but also keep you informed of incoming calls.",
      brand: "Willful",
      price: 29.99,
      image: require("@/assets/images/pages/eCommerce/25.png"),
      hasFreeShipping: true,
      rating: 5,
      qty: 3,
    },
    {
      id: 4,
      name: "College Bag Bookbags for Women",
      slug: "ronyes-unisex-college-bag-bookbags-for-women-4",
      description:
        "Made of high quality water-resistant material; padded and adjustable shoulder straps; external USB with built-in charging cable offers a convenient charging",
      brand: "Ronyes",
      price: 23.99,
      image: require("@/assets/images/pages/eCommerce/24.png"),
      hasFreeShipping: true,
      rating: 2,
      qty: 1,
    },
    {
      id: 5,
      name: "2TB Portable External Hard Drive",
      slug: "toshiba-canvio-advance-2-tb-portable-external-hard-drive-5",
      description:
        "Up to 3TB of storage capacity to store your growing files and content",
      brand: "Toshiba",
      price: 69.99,
      image: require("@/assets/images/pages/eCommerce/23.png"),
      hasFreeShipping: true,
      rating: 2,
      qty: 5,
    },
    {
      id: 6,
      name: "High Performance Bluetooth Tracker",
      slug: "tile-pro-high-performance-bluetooth-tracker-6",
      description:
        "FIND KEYS, BAGS & MORE -- Pro is our high-performance finder ideal for keys, backpacks, luggage or any other items you want to keep track of. The easy-to-use finder and free app work with iOS and Android.",
      brand: "Tile",
      price: 29.99,
      image: require("@/assets/images/pages/eCommerce/22.png"),
      hasFreeShipping: false,
      rating: 4,
      qty: 2,
    },
  ],
  newCustomers: [
    {
      avatar: require("@/assets/images/avatars/Arabi.png"),
      title: "Ebad Ali",
      address: "Abu Dhabi, P.O.Box 9966, Al Qouz, Dubai, UAE ",
      customClass: "mb-2 mb-xl-0",
    },
    {
      avatar: require("@/assets/images/avatars/2.png"),
      title: "Hamad Qasam",
      address: "Abu Dhabi, P.O.Box 9966, Al Qouz, Dubai, UAE ",
      customClass: "mb-2 mb-xl-0",
    },
    {
      avatar: require("@/assets/images/avatars/2.png"),
      title: "Hamad Qasam",
      address: "Abu Dhabi, P.O.Box 9966, Al Qouz, Dubai, UAE ",
      customClass: "mb-2 mb-xl-0",
    },
    {
      avatar: require("@/assets/images/avatars/2.png"),
      title: "Hamad Qasam",
      address: "Abu Dhabi, P.O.Box 9966, Al Qouz, Dubai, UAE ",
      customClass: "mb-2 mb-xl-0",
    },
  ],
};
/* eslint-disable global-require */
mock.onGet("/ecommerce/data").reply(() => [200, data]);
